/**
 * Extension that provides table block context to Slate editors in table block cells
 * This allows the editor to access block props like onChangeBlock and data
 */

export const withTableBlockContext = (editor) => {
  // Store the table block context
  let tableBlockContext = null;

  /**
   * Sets the table block context (called from the table block Cell component)
   * @param {Object} context - Table block context containing block, data, onChangeBlock, etc.
   */
  editor.setTableBlockContext = (context) => {
    tableBlockContext = context;
  };

  /**
   * Gets the table block context
   * @returns {Object|null} Table block context or null if not in a table block
   */
  editor.getBlockProps = () => {
    return tableBlockContext;
  };

  /**
   * Checks if the editor is within a table block context
   * @returns {boolean}
   */
  editor.isInTableBlock = () => {
    return (
      tableBlockContext &&
      tableBlockContext.data &&
      tableBlockContext.data.table
    );
  };

  return editor;
};
